import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../Roles and Permissions/Filters/MultiSelect";
import Add from "./Add";
import View from "./View";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

async function fetchProductUniqueValues() {
  try {
    const response = await get(`/master/product/getAll`);
    const list = response.data.data || [];
    const uniqueCountries = [
      ...new Set(
        list.map((el) => el.country).filter(Boolean), // Filter out undefined values
      ),
    ];
    return {
      country: uniqueCountries,
      allProducts: list,
    };
  } catch (error) {
    console.error("Error fetching unique values:", error);
    return { country: [], allProducts: [] };
  }
}

const List = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Country: false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [allProductsForDuplicateCheck, setAllProductsForDuplicateCheck] =
    useState([]);
  const [errors, setErrors] = useState({
    Date: false,
    Country: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    country: [],
  });
  const filters = ["Date"];
  const simpleUnits = [
    {
      Mass: ["Gram", "Kilogram", "Metric Tonne", "Milligram"],
    },
    {
      Volume: ["Milliliter", "Liter", "Cubic Meter", "Cubic Centimeter"],
    },
    {
      Bulk: [
        "Per Batch",
        "Per Lot",
        "Per Unit of Product",
        "Per Drum / Container",
        "Per Reactor Cycle",
        "Per Run",
      ],
    },
    {
      Time: [
        "Per Hour (Hr)",
        "Per Day",
        "Per Shift",
        "Per Week",
        "Per Month",
        "Per Year",
      ],
    },
    {
      Operational: [
        "Per Machine",
        "Per Equipment",
        "Per Production Line",
        "Per Facility",
      ],
    },
  ];
  const typeofemissions = [
    "Carbon dioxide ; CO2",
    "Methane – non-fossil ; CH4",
    "Methane – fossil ; CH4",
    "Nitrous oxide ; N2O",
    "Nitrogen trifluoride ; NF3",
    "Sulfur hexafluoride ; SF6",
    "HFC-23 ; CHF3",
    "HFC-32 ; CH2F2",
    "HFC-41 ; CH3F",
    "HFC-125 ; CHF2CF3",
    "HFC-134 ; CHF2CHF2",
    "HFC-134a ; CH2FCF3",
    "HFC-143 ; CH2FCHF2",
    "HFC-143a ; CH3CF3",
    "HFC-152 ; CH2FCH2F",
    "HFC-152a ; CH3CHF2",
    "HFC-161 ; CH3CH2F",
    "HFC-227ca ; CF3CF2CHF2",
    "HFC-227ea ; CF3CHFCF3",
    "HFC-236cb ; CH2FCF2CF3",
    "HFC-236ea ; CHF2CHFCF3",
    "HFC-236fa ; CF3CH2CF3",
    "HFC-245ca ; CH2FCF2CHF2",
    "HFC-245cb ; CF3CF2CH3",
    "HFC-245ea ; CHF2CHFCHF2",
    "HFC-245eb ; CH2FCHFCF3",
    "HFC-245fa ; CHF2CH2CF3",
    "HFC-263fb ; CH3CH2CF3",
    "HFC-272ca ; CH3CF2CH3",
    "HFC-329p ; CHF2CF2CF2CF3",
    "HFC-365mfc ; CH3CF2CH2CF3",
    "HFC-43-10mee ; CF3CHFCHFCF2CF3",
    "HFO-1123 ; CHF=CF2",
    "HFO-1132a ; CH2=CF2",
    "HFO-1141 ; CH2=CHF",
    "HFO-1225ye(Z) ; (Z)-CF3CF=CHF",
    "HFO-1225ye(E) ; (E)-CF3CF=CHF",
    "HFO-1234ze(Z) ; (Z)-CF3CH=CHF",
    "HFO-1234ze(E) ; (E)-CF3CH=CHF",
    "HFO-1234yf ; CF3CF=CH2",
    "HFO-1336mzz(E) ; (E)-CF3CH=CHCF3",
    "HFO-1336mzz(Z) ; (Z)-CF3CH=CHCF3",
    "HFO-1243zf ; CF3CH=CH2",
    "HFO-1345zfc ; CF3CF2CH=CH2",
    "3,3,4,4,5,5,6,6,6-nonafluorohex-1-ene ; n-C4F9CH=CH2",
    "3,3,4,4,5,5,6,6,7,7,8,8,8-tridecafluorooct-1-ene ; n-C6F13CH=CH2",
    "3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,10-heptadecafluorodec-1-ene ; n-C8F17CH=CH2",
    "3,3,3-trifluoro-2-(trifluoromethyl)prop-1-ene ; (CF3)2C=CH2",
    "1,1,2,2,3,3-hexafluorocyclopentane ; cyc-CF2CF2CF2CH2CH2",
    "1,1,2,2,3,3,4-heptafluorocyclopentane ; cyc-CF2CF2CF2CHFCH2",
    "1,3,3,4,4,5,5-heptafluorocyclopentene ; cyc-CF2CF2CF2CF=CH",
    "(4s,5s)-1,1,2,2,3,3,4,5-octafluorocyclopentane ; trans-cyc-CF2CF2CF2CHFCHF",
    "HFO-1438ezy(E) ; (E)-(CF3)2CFCH=CHF",
    "HFO-1447fz ; CF3(CF2)2CH=CH2",
    "1,3,3,4,4-pentafluorocyclobutene ; cyc-CH=CFCF2CF2",
    "3,3,4,4-tetrafluorocyclobutene ; cyc-CH=CHCF2CF2",
    "PFC-14 ; CF4",
    "PFC-116 ; C2F6",
    "PFC-218 ; C3F8",
    "PFC-c216 ; c-C3F6",
    "PFC-C-318 (PFC-318) ; cyc-CF2CF2CF2CF2",
    "PFC-31-10 ; n-C4F10",
    "PFC-41-12 ; n-C5F12",
    "PFC-51-14 ; n-C6F14",
    "PFC-61-16 ; n-C7F16",
    "PFC-71-18 ; n-C8F18",
    "PFC-91-18 ; C10F18",
    "PFC-1114 ; CF2=CF2",
    "PFC-1216 ; CF3CF=CF2",
    "Pentadecafluorotriethylamine ; N(C2F5)3",
    "Perfluorotripropylamine ; N(CF2CF2CF3)3",
    "Heptacosafluorotributylamine ; N(CF2CF2CF2CF3)3",
    "Perfluorotripentylamine ; N(CF2CF2CF2CF2CF3)3",
    "Heptafluoroisobutyronitrile ; (CF3)2CFCN",
    "Trifluoromethylsulfur pentafluoride ; SF5CF3",
    "Sulfuryl fluoride ; SO2F2",
    "Hexafluoro-cyclobutene ; cyc-CF=CFCF2CF2",
    "Octafluoro-cyclopentene (Perfluorocyclopentene) ; cyc-CF=CFCF2CF2CF2",
    "1,1,2,2,3,3,4,4,4a,5,5,6,6,7,7,8,8,8a-octadecafluoronaphthalene (Perfluorodecalin (cis)) ; (Z)-C10F18",
    "1,1,2,2,3,3,4,4,4a,5,5,6,6,7,7,8,8,8a-octadecafluoronaphthalene (Perfluorodecalin (trans)) ; (E)-C10F18",
    "1,1,2,3,4,4-hexafluorobuta-1,3-diene ; CF2=CFCF=CF2",
    "Octafluoro-1-butene ; CF3CF2CF=CF2",
    "Octafluoro-2-butene ; CF3CF=CFCF3",
    "CFC-11 ; CCl3F",
    "CFC-12 ; CCl2F2",
    "CFC-13 ; CClF3",
    "CFC-112 ; CCl2FCCl2F",
    "CFC-112a ; CCl3CClF2",
    "CFC-113 ; CCl2FCClF2",
    "CFC-113a ; CCl3CF3",
    "CFC-114 ; CClF2CClF2",
    "CFC-114a ; CCl2FCF3",
    "CFC-115 ; CClF2CF3",
    "E-R316c ; trans-cyc-CClFCF2CF2CClF",
    "Z-R316c ; cis-cyc-CClFCF2CF2CClF",
    "CFC-1112 ; CClF=CClF",
    "CFC-1112a ; CCl2=CF2",
    "HCFC-21 ; CHCl2F",
    "HCFC-22 ; CHClF2",
    "HCFC-31 ; CH2ClF",
    "HCFC-121 ; CHCl2CCl2F",
    "HCFC-122 ; CHCl2CClF2",
    "HCFC-122a ; CHClFCCl2F",
    "HCFC-123 ; CHCl2CF3",
    "HCFC-123a ; CHClFCClF2",
    "HCFC-124 ; CHClFCF3",
    "HCFC-124a ; CHF2CClF2",
    "HCFC-132 ; CHClFCHClF",
    "HCFC-132a ; CHCl2CHF2",
    "HCFC-132c ; CH2FCCl2F",
    "HCFC-133a ; CH2ClCF3",
    "HCFC-141 ; CH2ClCHClF",
    "HCFC-141b ; CH3CCl2F",
    "HCFC-142b ; CH3CClF2",
    "HCFC-225ca ; CHCl2CF2CF3",
    "HCFC-225cb ; CHClFCF2CClF2",
    "HCFO-1233zd(E) ; (E)-CF3CH=CHCl",
    "HCFO-1233zd(Z) ; (Z)-CF3CH=CHCl",
    "(E)-1-chloro-2-fluoroethene ; (E/Z)-CHCl=CHF",
    "(E)-1-chloro-3,3,3-trifluoroprop-1-ene ; trans-CF3CH=CHCl",
    "Methyl chloroform ; CH3CCl3",
    "Carbon tetrachloride ; CCl4",
    "Methyl chloride ; CH3Cl",
    "Methylene chloride ; CH2Cl2",
    "Chloroform ; CHCl3",
    "Chloroethane ; CH3CH2Cl",
    "1,2-dichloroethane ; CH2ClCH2Cl",
    "1,1,2-trichloroethene ; CHCl=CCl2",
    "1,1,2,2-tetrachloroethene ; CCl2=CCl2",
    "2-chloropropane ; CH3CHClCH3",
    "1-chlorobutane ; CH3(CH2)2CH2Cl",
    "Methyl bromide ; CH3Br",
    "Methylene bromide ; CH2Br2",
    "Halon-1201 ; CHBrF2",
    "Halon-1202 ; CBr2F2",
    "Halon-1211 ; CBrClF2",
    "Halon-1301 ; CBrF3",
    "Halon-2301 ; CH2BrCF3",
    "Halon-2311 ; CHBrClCF3",
    "Halon-2401 ; CHBrFCF3",
    "Halon-2402 ; CBrF2CBrF2",
    "Tribromomethane ; CHBr3",
    "Halon-1011 ; CH2BrCl",
    "Bromoethane ; CH3CH2Br",
    "1,2-dibromoethane ; CH2BrCH2Br",
    "1-bromopropane ; CH3CH2CH2Br",
    "2-bromopropane ; CH3CHBrCH3",
    "HFE-125 ; CHF2OCF3",
    "HFE-134 ; CHF2OCHF2",
    "HFE-143a ; CH3OCF3",
    "HFE-227ea ; CF3CHFOCF3",
    "HCFE-235ca2 ; CHF2OCF2CHFCl",
    "HCFE-235da2 ; CHF2OCHClCF3",
    "HFE-236ea2 ; CHF2OCHFCF3",
    "HFE-236fa ; CF3CH2OCF3",
    "HFE-245cb2 ; CF3CF2OCH3",
    "HFE-245fa1 ; CHF2CH2OCF3",
    "HFE-245fa2 ; CHF2OCH2CF3",
    "2,2,3,3,3-pentafluoropropan-1-ol ; CF3CF2CH2OH",
    "HFE-254cb1 ; CH3OCF2CHF2",
    "HFE-254cb2 ; CH3OCF2CHF2",
    "HFE-236ca ; CHF2OCF2CHF2",
    "HFE-263mf (HFE-263fb2) ; CF3CH2OCH3",
    "HFE-263m1 ; CF3OCH2CH3",
    "HFE-365mcf2 ; CF3CF2OCH2CH3",
    "3,3,3-trifluoropropan-1-ol ; CF3CH2CH2OH",
    "HFE-329mcc2 ; CHF2CF2OCF2CF3",
    "HFE-338mmz1 ; (CF3)2CHOCHF2",
    "HFE-338mcf2 ; CF3CH2OCF2CF3",
    "HFE-347mmz1 ; (CF3)2CHOCH2F",
    "HFE-347mcc3 ; CH3OCF2CF2CF3",
    "HFE-347mcf2 ; CHF2CH2OCF2CF3",
    "HFE-347pcf2 ; CHF2CF2OCH2CF3",
    "HFE-347mmy1 ; (CF3)2CFOCH3",
    "HFE-356mec3 ; CH3OCF2CHFCF3",
    "HFE-356mff2 ; CF3CH2OCH2CF3",
    "HFE-356pcf2 ; CHF2CH2OCF2CHF2",
    "HFE-356pcf3 ; CHF2OCH2CF2CHF2",
    "HFE-356pcc3 ; CH3OCF2CF2CHF2",
    "HFE-356mmz1 ; (CF3)2CHOCH3",
    "HFE-365mcf3 ; CF3CF2CH2OCH3",
    "HFE-374pc2 ; CHF2CF2OCH2CH3",
    "4,4,4-trifluorobutan-1-ol ; CF3(CH2)2CH2OH",
    "2,2,3,3,4,4,5,5-octafluorocyclopentan-1-ol ; cyc-(CF2)4CH(OH)",
    "HFE-43-10pccc124 ; CHF2OCF2OCF2CF2OCHF2",
    "HFE-449s1 ; C4F9OCH3",
    "HFE-449sl ; C4F9OCH3",
    "n-HFE-7100 ; CF3CF2CF2CF2OCH3",
    "n-HFE-7200 ; n-C4F9OC2H5",
    "i-HFE-7100 ; (CF3)2CFCF2OCH3",
    "HFE-569sf2 ; C4F9OC2H5",
    "i-HFE-7200 ; (CF3)2CFCF2OCH2CH3",
    "HFE-7300 ; (CF3)2CFCFOC2H5CF2CF2CF3",
    "HFE-7500 ; n-C3F7CFOC2H5CF(CF3)2",
    "HFE-236ca12 ; CHF2OCF2OCHF2",
    "HFE-338pcc13 ; CHF2OCF2CF2OCHF2",
    "1,1,1,3,3,3-hexafluoropropan-2-ol ; (CF3)2CHOH",
    "HG-02 ; CHF2(OCF2CF2)2OCHF2",
    "HG-03 ; CHF2(OCF2CF2)3OCHF2",
    "HG-20 ; HF2C(OCF2)2OCF2H",
    "HG-21 ; HF2COCF2CF2OCF2OCF2OCF2H",
    "HG-30 ; HF2C(OCF2)3OCF2H",
    "Fluroxene ; CF3CH2OCH=CH2",
    "1,1,2,2-tetrafluoro-1-(fluoromethoxy)ethane ; CH2FOCF2CF2H",
    "2-ethoxy-3,3,4,4,5-pentafluorotetrahydro-2,5-bis[1,2,2,2-tetrafluoro-1-(trifluoromethyl)ethyl]furan ; C12H5F19O2",
    "Difluoro(methoxy)methane ; CH3OCHF2",
    "HG'-01 ; CH3OCF2CF2OCH3",
    "HG'-02 ; CH3O(CF2CF2O)2CH3",
    "HG'-03 ; CH3O(CF2CF2O)3CH3",
    "HFE-329me3 ; CF3CFHCF2OCF3",
    "3,3,4,4,5,5,6,6,7,7,7-undecafluoroheptan-1-ol ; CF3(CF2)4CH2CH2OH",
    "3,3,4,4,5,5,6,6,7,7,8,8,9,9,9-pentadecafluorononan-1-ol ; CF3(CF2)6CH2CH2OH",
    "3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,11-nonadecafluoroundecan-1-ol ; CF3(CF2)8CH2CH2OH",
    "2-chloro-1,1,2-trifluoro-1-methoxyethane ; CH3OCF2CHClF",
    "PFPMIE ; CF3OCF(CF3)CF2OCF2OCF3",
    "HFE-216 ; CF3OCF=CF2",
    "Perfluoroethyl formate ; CF3CF2OCHO",
    "2,2,2-trifluoroethyl formate ; CF3CH2OCHO",
    "Formic acid;1,1,1,3,3,3-hexafluoropropan-2-ol ; (CF3)2CHOCHO",
    "Ethenyl 2,2,2-trifluoroacetate ; CF3COOCH=CH2",
    "Ethyl 2,2,2-trifluoroacetate ; CF3COOCH2CH3",
    "Prop-2-enyl-2,2,2-trifluoroacetate ; CF3COOCH2CH=CH2",
    "Methyl 2,2,2-trifluoroacetate ; CF3COOCH3",
    "2,2,3,3,4,4,4-heptafluorobutan-1-ol ; CF3CF2CF2CH2OH",
    "1,1,2-trifluoro-2-(trifluoromethoxy)ethane ; CHF2CHFOCF3",
    "1-ethoxy-1,1,2,3,3,3-hexafluoropropane ; CF3CHFCF2OCH2CH3",
    "1,1,1,2,2,3,3-heptafluoro-3-(1,2,2,2-tetrafluoroethoxy)propane ; CF3CF2CF2OCHFCF3",
    "2,2,3,3-tetrafluoropropan-1-ol ; CHF2CF2CH2OH",
    "2,2,3,4,4,4-hexafluorobutan-1-ol ; CF3CHFCF2CH2OH",
    "1,1,2,2-tetrafluoro-3-methoxypropane ; CHF2CF2CH2OCH3",
    "1,1,1,2,2,4,5,5,5-nonafluoro-4-(trifluoromethyl)pentan-3-one ; CF3CF2COCF(CF3)2",
    "3,3,3-trifluoropropanal ; CF3CH2CHO",
    "2-fluoroethanol ; CH2FCH2OH",
    "2,2-difluoroethanol ; CHF2CH2OH",
    "2,2,2-trifluoroethanol ; CF3CH2OH",
    "HG-04 ; CHF2O(CF2CF2O)4CHF2",
    "Methyl-perfluoro-heptene-ethers ; CH3OC7F13",
    "1,1,1-trifluoro-propan-2-one ; CF3COCH3",
    "1,1,1-trifluoro-butan-2-one ; CF3COCH2CH3",
    "1-chloro-2-ethen-oxyethane ; ClCH2CH2OCH=CH2",
    "Octafluoro-oxolane ; c-C4F8O",
  ];

  const inputData = [
    [
      // {
      //   fieldName: "date",
      //   title: "Date",
      //   placeholder: "Date",
      //   disabled: true,
      //   colwidth: "48%",
      // },
      // {
      //   fieldName: "productName",
      //   title: "Product Name",
      //   placeholder: "Product Name",
      //   type: "input",
      //   colwidth: "67%",
      // },
      // {
      //   fieldName: "productId",
      //   title: "Product ID",
      //   placeholder: "Product ID",
      //   type: "input",
      //   colwidth: "67%",
      // },
      // {
      //   fieldName: "productCategory",
      //   title: "Product Category (Material of product)",
      //   placeholder: "Select Material",
      //   type: "select",
      //   colwidth: "67%",
      //   options: productCategoryOptions,
      // },
      // {
      //   fieldName: "productDescription",
      //   title: "Product Description",
      //   placeholder: "Product Description",
      //   type: "input",
      //   colwidth: "67%",
      // },
      // {
      //   fieldName: "averageWeightPerUnit",
      //   title: "Average weight per unit of product",
      //   placeholder: "Enter no",
      //   type: "input",
      //   colwidth: "48%",
      // },
      // {
      //   fieldName: "averageWeightPerUnitUnit",
      //   title: "Weight Unit",
      //   placeholder: "Select unit",
      //   type: "select",
      //   colwidth: "48%",
      //   options: ["Kg", "Tonnes"] || [],
      // },
      // {
      //   fieldName: "averageAnnualEnergyConsumption",
      //   title: "Average annual energy consumption",
      //   placeholder: "Enter value",
      //   type: "input",
      //   colwidth: "48%",
      // },
      // {
      //   fieldName: "averageAnnualEnergyConsumptionUnit",
      //   title: "Unit",
      //   placeholder: "Select unit",
      //   type: "select",
      //   colwidth: "48%",
      //   options: ["Kg", "Tonnes"] || [],
      // },
      // {
      //   fieldName: "frequencyOfMaintenancePerYear",
      //   title: "Frequency of Maintenance per year",
      //   placeholder: "Enter Number",
      //   type: "input",
      //   colwidth: "66%",
      // },
      // {
      //   fieldName: "energyOrFuelUsedForMaintenance",
      //   title: "Energy or Fuel Used for Maintenance",
      //   placeholder: "Enter quantity",
      //   type: "input",
      //   colwidth: "48%",
      // },
      // {
      //   fieldName: "energyOrFuelUsedForMaintenanceUnit",
      //   title: "Energy/Fuel Unit",
      //   placeholder: "Select unit",
      //   type: "select",
      //   colwidth: "48%",
      //   options: simpleUnits?.flatMap((u) => Object.values(u)[0]) || [],
      // },
      // {
      //   fieldName: "energyTypeRequiredForUse",
      //   title :"Energy type required for use",
      //   placeholder: "Select energy type",
      //   type: "select",
      //   colwidth: "66%",
      //   // options: energyTypeOptions,
      // },
      // {
      //   fieldName: "disposalMethod",
      //   title: "Disposal Method",
      //   placeholder: "Select Method",
      //   type: "select",
      //   colwidth: "66%",
      //   options: disposalMethodOptions,
      // },
      // {
      //   fieldName: "expectedLifetimeOfTheProductYears",
      //   title: "Expected Lifetime of the Product (years)",
      //   placeholder: "Enter life in years",
      //   type: "input",
      //   colwidth: "66%",
      // },
    ],
    {
      header: "Sample Used for Testing",
      colwidth: "100%",
    },
    [
      {
        fieldName: "sampleBasis",
        title: "Sample Basis",
        placeholder: "Mass",
        type: "select",
        colwidth: "32%",
        options: ["Mass", "Volume", "Bulk", "Time", "Operational"],
      },
      {
        fieldName: "sampleQuantity",
        title: "Sample Quantity",
        placeholder: "Enter Quantity",
        colwidth: "31%",
      },
      {
        fieldName: "unit",
        title: "Unit",
        placeholder: "Unit",
        colwidth: "31.5%",
        options: simpleUnits,
      },
    ],
    [
      {
        fieldName: "processes.processName",
        title: "Process Name",
        placeholder: "Enter Process Name",
        colwidth: "47%",
      },
      {
        fieldName: "processes.emissions",
        title: "Emission to Air",
        placeholder: "Select",
        type: "select",
        colwidth: "50%",
        options: typeofemissions,
      },
    ],
  ];

  const filtersToApply = useMemo(
    () => ({
      // company: companyId,
      startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
      endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
      country: selectedFields?.country.join(",") || [],
    }),
    [startDate, endDate, selectedFields],
  );

  // fetching Vehicle data
  const fetchData = useCallback(
    async (filters) => {
      const resolvedFilters =
        filters !== undefined
          ? filters
          : isFiltersApplied
            ? filtersToApply
            : {};
      try {
        const queryParams = new URLSearchParams({
          ...resolvedFilters,
          page, // Add the current page
          limit: 10, // Add the number of rows per page
          sortField: sortConfig.key, // Sort configuration
          sortOrder: sortConfig.direction,
        }).toString();
        const response = await get(`/master/product/getAll?${queryParams}`);
        console.log(response.data.data, "response.data.data");
        setData(response.data.data); // Update the user list
        setTotalPages(response.data.totalPages); // Update total pages for pagination
        const uniqueResult = await fetchProductUniqueValues();
        setUniqueValues({ country: uniqueResult.country });
        setAllProductsForDuplicateCheck(uniqueResult.allProducts || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    },
    [
      page,
      sortConfig,
      isFiltersApplied,
      filtersToApply,
    ],
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      country: [],
    });
    setPage(1);
    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = startDate || endDate ? true : false;
    const isCountryApplied = selectedFields.country?.length > 0 ? true : false;
    setIsFiltersApplied(isDateApplied || isCountryApplied);
    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Country: isCountryApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const filterResetWithoutApply = () => {
    // Reset the selected filter only if changes were made
    if (selectedFilter === "Date") {
      setStartDate(null);
      setEndDate(null);
    } else if (selectedFilter === "Country") {
      setSelectedFields((prevState) => ({
        ...prevState,
        country: [], // Reset the 'facility' field
      }));
    }
    setDrawerFilterOpen(false); // Close the drawer without resetting everything
  };

  const handleFilterDrawer = () => {
    if (appliedFilters?.Date) setDrawerFilterOpen(false);
    // Close the drawer without resetting everything
    else filterResetWithoutApply();
  };

  const columnHeadings = [
    {
      fieldName: "createdAt",
      title: "Date",
    },
    {
      fieldName: "productName",
      title: "Product Name",
    },
    {
      fieldName: "noOfProcesses",
      title: "No. of Processes",
    },
    {
      fieldName: "totalEmission",
      title: "Total Emissions",
    },
    {
      fieldName: "unit",
      title: "Unit",
    },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            url={`${api}/master/purchasedGoods`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
      case "Country":
        return (
          <MultiSelect
            title="Country"
            url={`${api}/master/purchasedGoods`}
            selectedField={selectedFields.country}
            selectedFields={selectedFields}
            setSelectedFields={setSelectedFields}
            errors={errors.Country}
            setErrors={setErrors}
            field="country"
            data={uniqueValues.country}
          />
        );

      default:
        return (
          <DateRangePickerComponent
            url={`${api}/master/purchasedGoods`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
    }
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height
      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);
  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            // padding: "20px",
            backgroundColor: "#ededed",
            width: "100%",
            // height: "100vh",
            // overflowY: "scroll",
            // overflowX: "hidden",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <Add
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={data}
            allProductsForDuplicateCheck={allProductsForDuplicateCheck}
            element={element}
            typeofemissions={typeofemissions}
            addUrl={`${api}/master/product/create`}
            updateUrl={`${api}/master/product/update`}
            // details={vehicle}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
            simpleUnits={simpleUnits}
          />
          <View
            id={element ? element._id : ""}
            data={element}
            view={viewData}
            setView={setViewData}
            inputData={[
              {
                title: "Process Name",
                colwidth: "26%",
                filedName: "processes",
                placeholder: "Process Name",
              },
              {
                title: "Emission",
                field: "emissions",
                placeholder: "Emission",
              },
              {
                title: "Quantity",
                field: "unit",
                placeholder: "Enter Quantity",
                type: "select",
              },
              {
                title: "Unit",
                field: "unit",
                type: "select",
                placeholder: "Select Unit",
              },
            ]}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <DeleteDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/master/product/delete`,
                method: "delete",
                setsnackOpen,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenu
            setData={setElement}
            setAddData={setAddData}
            {...{
              heading: "Product Master",
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%" }}
          >
            <Box>
              <TableHeading heading={"Product Master"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 25% 17% 20% 17% 8%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 25% 17% 20% 17% 8%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.field}
                        {...{
                          fieldData:
                            typeof item[el.fieldName] === "object" &&
                            item[el.fieldName] !== null
                              ? item[el.fieldName]
                              : item[el.fieldName],
                          dateField:
                            el.fieldName === "createdAt"
                              ? item.createdAt
                              : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent} // Pass this state to PaginationBox
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default List;
